import { Box, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import AddProject from "../assets/SVG/addProject";
import addGroupPicError from "../assets/image/groupImageError.png";
import CreateProjectPop from "../components/project/createProjectPop";
import { useEffect } from "react";
import { deleteProject, getAllProject } from "../api/project";
import Bookmark from "../assets/SVG/bookmark";
import DeleteIcon from "../assets/SVG/deleteIcon";
import SearchIcon from "../assets/SVG/searchIcon";
import SearchInput from "../components/project/searchInput";

export default function Project() {
  const [openPopover, setOpenPopover] = useState();
  const [openPopoverEdit, setOpenPopoverEdit] = useState();
  const [dataProject, setDataProject] = useState();
  const [mode, setMode] = useState("create");
  const [data, setData] = useState();
  const [dataInfoGroup, setDataInfoGroup] = useState();
  const [searchInput, setSearchInput] = useState();

  const handleClickCardGroup = (info) => {
    setDataInfoGroup(info);
    setMode("view");
  };
  const handleDataProject = (item) => {
    setDataProject(item);
  };
  useEffect(() => {
    getAllProject()
      .then((x) => {
        setData(x);
        setState({ list: x });
      })
      .catch(() => {});
  }, [openPopoverEdit, openPopover]);

  const handleChange = (e) => {
    setSearchInput(e.target.value);
    const results = data.filter((x) => {
      if (e.target.value === "") return data;
      else {
        if (x.name === undefined) {
          // setShowLoading(true);
        } else {
          return x.name.toLowerCase().includes(e.target.value.toLowerCase());
        }
      }
    });

    setState({
      query: e.target.value,
      list: results,
    });
  };
  const [state, setState] = useState({
    query: "",
    list: [],
  });

  return (
    <>
      <CreateProjectPop
        openPopover={openPopover}
        setOpenPopover={setOpenPopover}
      />
      <CreateProjectPop
        defData={dataProject}
        openPopover={openPopoverEdit}
        setOpenPopover={setOpenPopoverEdit}
      />
      <Box
        mt="3%"
        display="flex"
        width="fit-content"
        alignItems="center"
        onClick={(e) => {
          setOpenPopover(e.currentTarget);
        }}
        sx={{ cursor: "pointer" }}
      >
        <AddProject />
        <Typography color="#4C8395" fontSize="16px" mr="10px">
          {"افزودن پروژه"}
        </Typography>
      </Box>
      <Typography mb="20px" className="title_GroupOnline">
        {"پروژه ها"}
      </Typography>
      <SearchInput value={searchInput} onChange={handleChange} />
      <Box display="flex" gap="10px" flexWrap={"wrap"}>
        {data?.length >= 1 &&
          state?.list.map((item) => (
            <>
              <Box
                p="10px"
                bgcolor="#F5F9FF"
                borderRadius="12px"
                width="210px"
                height="170px"
                boxShadow={"0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}
                sx={{ cursor: "pointer" }}
              >
                <Box
                  sx={{
                    overflow: "auto",
                    height: "100%",
                    px: "5px",
                    direction: "ltr",
                    "::-webkit-scrollbar-thumb": {
                      background: "#126E83",
                      // borderRadius: "10px"
                    },
                    "::-webkit-scrollbar-track": {
                      background: "#A7C9D1",
                      borderRadius: "10px",
                    },
                  }}
                >
                  <Box position="sticky" top="0px" bgcolor="#F5F9FF">
                    <Box
                      display="flex"
                      justifyContent={"space-between"}
                      alignItems="center"
                      sx={{ direction: "rtl" }}
                    >
                      <Typography
                        fontWeight="bold"
                        color="var(--emr-font)"
                        fontSize={"20px"}
                        mt="15px"
                        onClick={(e) => {
                          setOpenPopoverEdit(e.currentTarget);
                          handleDataProject(item);
                        }}
                      >
                        {item.name}
                      </Typography>
                      <Box display="flex">
                        <Box
                          mt="3px"
                          onClick={() => {
                            deleteProject(item.id)
                              .then(() => {
                                getAllProject()
                                  .then((x) => setState({ list: x }))
                                  .catch(() => {});
                              })
                              .catch(() => {});
                          }}
                        >
                          <DeleteIcon size="1.5" />
                        </Box>
                        <Bookmark color={`var(--emr-${item.color})`} />
                      </Box>
                    </Box>

                    <Box sx={{ direction: "rtl" }} mt="10px" display={"flex"}>
                      <Typography mr="8px" fontSize={"14px"} color="#6C6969">
                        {`${item.startAt.split(" ", 1)} - ${item.endAt.split(
                          " ",
                          1
                        )}`}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                  // sx={{
                  //   overflow: "auto",
                  //   height: "100px",
                  //   direction: "ltr",
                  //   "::-webkit-scrollbar-thumb": {
                  //     background: "#126E83",
                  //     // borderRadius: "10px"
                  //   },
                  //   "::-webkit-scrollbar-track": {
                  //     background:"#A7C9D1",
                  //     borderRadius: "10px",
                  //   }
                  // }}
                  >
                    {item?.groups?.length !== 0 && (
                      <>
                        {item?.groups?.map((x) => (
                          <Box
                            mt="10px"
                            alignItems={"center"}
                            gap="5px"
                            display={"flex"}
                            justifyContent="end"
                          >
                            <Typography
                              mr="8px"
                              fontSize={"14px"}
                              color="#6C6969"
                            >
                              {x?.name}
                            </Typography>
                            {x?.pic && (
                              <img
                                src={x?.pic}
                                style={{
                                  width: "25px",
                                  height: "auto",
                                  border: "solid 1px #126E839C",
                                  borderRadius: "50%",
                                }}
                              />
                            )}
                            {!x.pic && (
                              <Box
                                width="25px"
                                height="25px"
                                borderRadius="50%"
                                bgcolor={"gray"}
                              ></Box>
                            )}
                          </Box>
                        ))}
                      </>
                    )}
                  </Box>
                </Box>
              </Box>
            </>
          ))}
      </Box>
      {/* {data.length <= 0 && ( */}
      {data?.length === 0 && (
        <Box textAlign="center">
          <img src={addGroupPicError} style={{ marginTop: "0px" }} />
          <Typography
            mt="0
        0px"
          >
            {"گروه جهادی یافت نشد!"}
          </Typography>
        </Box>
      )}
      {/* )} */}
    </>
  );
}
